import { render, staticRenderFns } from "./CampagneCard.vue?vue&type=template&id=811e95aa&"
import script from "./CampagneCard.vue?vue&type=script&lang=js&"
export * from "./CampagneCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports